import { useState } from "react";
import { useT } from "../i18n/useT";

type Client = {
  name: string;
  domain: string;
  logo?: string;
};

const clients: Client[] = [
  { name: "Tipico", domain: "tipico.com" },
  { name: "MeDirect", domain: "medirect.com.mt" },
  { name: "Aspire Global", domain: "aspireglobal.com", logo: "/clients/aspire-global.png" },
  { name: "NeoGames", domain: "neogames.com", logo: "/clients/neogames.png" },
  { name: "Blueground", domain: "theblueground.com" },
  { name: "Milmoh", domain: "milmoh.com" },
  { name: "Samegrid", domain: "samegrid.io", logo: "/clients/samegrid.png" },
];

function ClientCard({ c }: { c: Client }) {
  const [failed, setFailed] = useState(false);
  const src = c.logo ?? `https://www.google.com/s2/favicons?domain=${c.domain}&sz=128`;
  return (
    <li className="flex flex-col items-center justify-between gap-3 rounded-lg border border-ink-800 bg-ink-900/60 p-4 transition hover:border-ink-700 hover:bg-ink-900/90">
      <span className="flex h-9 w-full items-center justify-center rounded-md bg-ink-50/95 px-3">
        {failed ? (
          <span className="text-xs font-bold text-ink-700 leading-none">
            {c.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()}
          </span>
        ) : (
          <img
            src={src}
            alt={`${c.name} logo`}
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer"
            onError={() => setFailed(true)}
            className="max-h-7 max-w-full object-contain"
          />
        )}
      </span>
      <span className="text-center text-xs font-medium text-ink-200 tracking-tight">
        {c.name}
      </span>
    </li>
  );
}

export default function Clients() {
  const t = useT();
  return (
    <section
      aria-label={t.clients.trustedBy}
      className="border-t border-ink-800/60 bg-ink-900/40"
    >
      <div className="container-page py-12 sm:py-14">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-ink-400">
          {t.clients.trustedBy}
        </p>
        <ul className="mt-7 grid grid-cols-3 gap-3 sm:grid-cols-4 lg:grid-cols-7">
          {clients.map((c) => (
            <ClientCard key={c.domain} c={c} />
          ))}
        </ul>
      </div>
    </section>
  );
}
